"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeSliderPrice = exports.numFormat = void 0;
const tooltip_1 = require("@pulse-web-ui/tooltip");
require("@reach/slider/styles.css");
const react_1 = __importStar(require("react"));
const range_slider_price_styles_1 = require("./range-slider-price.styles");
const range_slider_price_type_1 = require("./range-slider-price.type");
const numFormat = (number) => new Intl.NumberFormat('ru-RU').format(number);
exports.numFormat = numFormat;
let timeout;
const debounce = (callback, ms) => {
    return () => {
        clearTimeout(timeout);
        timeout = window.setTimeout(() => {
            callback();
        }, ms);
    };
};
const RangeSliderPrice = ({ min, max, step, disabled, onChange, error, warning, value, hasStepsMarkers, hasStepsLabel, currency = range_slider_price_type_1.CurrencyLabel.RUB, helperErrorText, label, hasTooltip, tooltipLabel, tooltipStyles, tooltipText, arrow, trigger, direction, isPriceFormatted, testId = 'rangeSlider', }) => {
    const [keyPressError, setKeyPressError] = (0, react_1.useState)(false);
    const [canChangeKeyPressError, setCanChangeKeyPressError] = (0, react_1.useState)(false);
    const formatter = (0, react_1.useCallback)((value) => {
        if (isPriceFormatted && value) {
            return `${(0, exports.numFormat)(Number(value))} ${currency}`;
        }
        return value ? `${value} ${currency}` : value;
    }, [currency, isPriceFormatted]);
    const debouncedSetCanChangeKeyPressError = debounce(() => {
        setCanChangeKeyPressError(true);
    }, 300);
    (0, react_1.useEffect)(() => {
        if (!!helperErrorText) {
            if (!canChangeKeyPressError) {
                debouncedSetCanChangeKeyPressError();
            }
            else {
                setKeyPressError(true);
            }
        }
        else {
            setCanChangeKeyPressError(false);
            setKeyPressError(false);
        }
    }, [value]);
    const handleChange = (value) => {
        onChange(value);
    };
    const getStepsMarkers = (0, react_1.useCallback)((min, max, step) => {
        const stepsMarkers = [];
        if (max === min) {
            return null;
        }
        for (let i = min + step; i < max; i += step) {
            stepsMarkers.push(i);
        }
        if (stepsMarkers.length > 0) {
            return stepsMarkers.map((s, i) => (react_1.default.createElement(range_slider_price_styles_1.StyledSliderMarker, { stepValue: value, filledStepsValue: s, value: s, disabled: disabled, error: error, warning: warning, "data-testid": `${testId}.marker.${s}` }, hasStepsLabel && (react_1.default.createElement(range_slider_price_styles_1.StyledSliderBox, null,
                react_1.default.createElement(range_slider_price_styles_1.StyledSliderMarkerCount, { currentStep: i }, formatter(String(s))))))));
        }
        return null;
    }, [min, max, step, value, disabled, error, warning, hasStepsLabel, formatter]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && (react_1.default.createElement(range_slider_price_styles_1.StyledLabelBox, null,
            react_1.default.createElement(range_slider_price_styles_1.StyledLabel, null, label),
            hasTooltip && (react_1.default.createElement(tooltip_1.Tooltip, { tooltipLabel: tooltipLabel, tooltipText: tooltipText, trigger: trigger, direction: direction, arrow: arrow, styles: tooltipStyles !== null && tooltipStyles !== void 0 ? tooltipStyles : {} })))),
        react_1.default.createElement(range_slider_price_styles_1.StyledWrapper, null,
            react_1.default.createElement(range_slider_price_styles_1.StyledRangeItemBox, null,
                react_1.default.createElement(range_slider_price_styles_1.StyledLeftCircle, { error: error, disabled: disabled }),
                react_1.default.createElement(range_slider_price_styles_1.StyledRightCircle, { error: error, disabled: disabled }),
                react_1.default.createElement(range_slider_price_styles_1.StyledRangeItem, { onDragStart: (e) => e.preventDefault(), disabled: disabled, error: error, warning: warning, min: min, max: max, step: step, value: value, onChange: handleChange, "data-testid": testId }, hasStepsMarkers && getStepsMarkers(min, max, step))))));
};
exports.RangeSliderPrice = RangeSliderPrice;
